import 'css-chunksrc/client/pages/exportsPage/customCpamReport/styles.scss';export default {
  "cpamReport": "_cpamReport_18cqk_1",
  "checked": "_checked_18cqk_7",
  "row": "_row_18cqk_11",
  "checkbox": "_checkbox_18cqk_20",
  "col": "_col_18cqk_26",
  "name": "_name_18cqk_30",
  "description": "_description_18cqk_37",
  "filters": "_filters_18cqk_42",
  "group": "_group_18cqk_51",
  "label": "_label_18cqk_60",
  "button": "_button_18cqk_67"
};